import { render, staticRenderFns } from "./IFRAMETab.vue?vue&type=template&id=07c8d712&"
import script from "./IFRAMETab.vue?vue&type=script&lang=js&"
export * from "./IFRAMETab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports